import React, { useState } from "react";
import { HiOutlineChatBubbleLeftRight, HiTrash } from "react-icons/hi2";

const ProjectInfoEditBanner = ({
  project,
  onEdit,
  onDelete,
  navigateToHub,
  isAdmin = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const projectImage =
    project?.image?.trim() ||
    "https://via.placeholder.com/150?text=Project+Image";

  return (
    <div
      className={`w-full max-w-7xl h-36 bg-white rounded-[20px] shadow-md p-6 flex items-center justify-between transition
        ${isAdmin && isHovered ? "shadow-lg scale-[1.01] cursor-pointer" : ""}
        ${!isAdmin ? "opacity-95 cursor-default" : ""}`}
      onClick={onEdit} // allow both admin & team to open modal
      onMouseEnter={() => isAdmin && setIsHovered(true)}
      onMouseLeave={() => isAdmin && setIsHovered(false)}
    >
      {/* Left side: image + title */}
      <div className="flex items-center gap-4">
        <div className="w-20 h-20 rounded-full overflow-hidden bg-zinc-200 flex items-center justify-center shrink-0">
          <img
            src={projectImage}
            alt={project?.title || "Project"}
            className="w-full h-full object-cover"
          />
        </div>

        <div className="flex flex-col">
          <div className="text-black text-3xl font-bold font-['Inter']">
            {project?.title || "Untitled Project"}
          </div>
        </div>
      </div>

      {/* Right side: actions */}
      {isAdmin && (
        <div className="flex gap-3 items-center">
          {/* Hub button if you later re-enable it */}
          {/* <button
            onClick={(e) => {
              e.stopPropagation();
              navigateToHub();
            }}
            className="flex items-center text-sm text-gray-700 hover:text-black font-medium"
          >
            <HiOutlineChatBubbleLeftRight className="mr-1 w-4 h-4" />
            Hub
          </button> */}

          <button
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
            className="text-red-500 hover:text-red-700"
            title="Delete Project"
          >
            <HiTrash className="w-5 h-5" />
          </button>
        </div>
      )}
    </div>
  );
};

export default ProjectInfoEditBanner;
